module.exports = __webpack_public_path__ + "smile.6d574087.png";